module.exports = __webpack_public_path__ + "img/friend-avatar.e7ecfe48.png";